var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13659_10303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1.5H4.25C3.42157 1.5 2.75 2.24619 2.75 3.16667V14.8333C2.75 15.7538 3.42157 16.5 4.25 16.5H14.75C15.5784 16.5 16.25 15.7538 16.25 14.8333V3.16667C16.25 2.24619 15.5784 1.5 14.75 1.5Z",
    fill: "#D3E9E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4982 4.65895C8.97337 4.0746 8.09818 3.91741 7.44061 4.4525C6.78303 4.9876 6.69045 5.88224 7.20685 6.5151C7.72325 7.14796 9.4982 8.625 9.4982 8.625C9.4982 8.625 11.2732 7.14796 11.7896 6.5151C12.306 5.88224 12.2247 4.98197 11.5558 4.4525C10.8869 3.92304 10.023 4.0746 9.4982 4.65895Z",
    fill: "#D3E9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 13.875H11.75M5.75 11.25H13.25M4.25 1.5H14.75C15.5784 1.5 16.25 2.24619 16.25 3.16667V14.8333C16.25 15.7538 15.5784 16.5 14.75 16.5H4.25C3.42157 16.5 2.75 15.7538 2.75 14.8333V3.16667C2.75 2.24619 3.42157 1.5 4.25 1.5ZM9.4982 4.65895C8.97337 4.0746 8.09818 3.91741 7.44061 4.4525C6.78303 4.9876 6.69045 5.88224 7.20685 6.5151C7.72325 7.14796 9.4982 8.625 9.4982 8.625C9.4982 8.625 11.2732 7.14796 11.7896 6.5151C12.306 5.88224 12.2247 4.98197 11.5558 4.4525C10.8869 3.92304 10.023 4.0746 9.4982 4.65895Z",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13659_10303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsIcon);
export default __webpack_public_path__ + "static/media/contracts-icon.d3dabe68.svg";
export { ForwardRef as ReactComponent };